// const jquery = require("jquery");
import "../styles/app.scss";
import "../node_modules/@splidejs/splide/dist/css/splide.min.css";
import Swup from "../node_modules/swup";

import { toggle } from "./toggle/toggle.js";
import { cookiePolicy } from "./cookiepolicy/cookiepolicy.js";
import { multilevel } from "./multilevel-nav/multilevel-nav.js";
import { windowheight } from "./windowheight/windowheight.js";
import { isAnimation } from "./animations/animations.js";
import { inheritLinks } from "./inherit-links/inherit-linnks.js";
import { projectFilter } from "./filters/filter-journal.js";
import { formFileUpload } from "./form-file-upload/formfileupload.js";
import Vimeo from "./lco-video";

import npl from "./next-post-logic/next-post-logic";
import scroller from "./parallax/scroller.js";

import $ from 'jquery';
import "./bigtext/bigtext.js";

import slider from "./slider/slider.js";

// NPL add state + Initialise build sequence
window.state = {
  npl: {
    enabled: false,
    catindex: 0,
    postindex: 0,
    i: 0,
    origincat: {},
    filtercat: {},
    origindata: {},
    filterdata: {},
  },
  video: [], // Used for Normal MP4 Files
  vimeo: {}, // Used for Vimeo Videos
};

npl.retrieveSequence(state);

// SWUP Page transitions
const swup = new Swup();

var elemental = require("./elem/elem.js");
let CookiesEuBanner = new cookiePolicy();
let Multilevel = new multilevel(".menu");

// Set up Toggles
let toggleNavicon = new toggle(
  "data-linknavicon",
  "data-targetnavicon",
  "active"
);

// Identify window height and add class to body
let WindowHeight = new windowheight();

export function main() {
  return
  // console.log("Javascript Started");
}

let newsletterFooterBtn = document.querySelector(".newsletter-overlay");
let newsletterFooterTitle = document.querySelector(".newsletter-btn");
let newsletterCloseBtn = document.querySelector(".atom-icon-cross");
let newsletterFakeBtn = document.querySelector(".newsletter-fakebtn");
let newsletterP = document.querySelector(".newsletter-form-top");

// Toggle Footer Newsletter
if (document.querySelector(".footer-newsletter")) {
  function openNewsletter() {
    document.querySelector(".footer-newsletter").classList.add("active");
    newsletterCloseBtn.classList.add("active");
    newsletterFooterTitle.textContent = "Join us today";
    newsletterFakeBtn.classList.remove("btn");
  }

  function closeNewsletter() {
    document.querySelector(".footer-newsletter").classList.remove("active");
    newsletterCloseBtn.classList.remove("active");
    newsletterFooterTitle.textContent = "Unlock news, views & culture";
    newsletterFakeBtn.classList.add("btn");
    newsletterFooterTitle.style.display = "block";
    newsletterP.style.display = "block";
    gravityNewsletterLoader();
  }

  newsletterFooterBtn.addEventListener("click", (e) => {
    e.preventDefault();
    openNewsletter();
  });

  newsletterFooterTitle.addEventListener("click", (e) => {
    e.preventDefault();
    openNewsletter();
  });

  newsletterCloseBtn.addEventListener("click", (e) => {
    e.preventDefault();
    closeNewsletter();
  });
}

// Accordion Controller
const initAccordion = () => {
  if (document.querySelector(".accordion-wrapper")) {
    // Get All Accordions On Page
    let accordions = document.querySelectorAll(".accordion-wrapper");
    // Loop
    accordions.forEach((accordion) => {
      // Get All Accodions Header
      let accordionHeaders = accordion.querySelectorAll(".accordion-header");
      // Loop
      accordionHeaders.forEach((accordionHeader) => {
        // If team member don't add active to all accordions
        if (document.querySelector(".team-member-list")) {
          document
            .querySelector(".team-member-list .team-member .accordion-header")
            .classList.add("active");
        } else {
          // Always Add active State To The First One
          accordion
            .querySelector("li:first-child > .accordion-header")
            .classList.add("active");
        }
        // Add Evt click
        accordionHeader.addEventListener("click", () => {
          // Check For active Class And Remove If Found On The accordionHeader Clicked
          if (accordionHeader.classList.contains("active")) {
            accordionHeader.classList.remove("active");
          } else {
            // Check All Other accordionHeaders And Remove active Class If Exists
            accordionHeaders.forEach((accordionHeader) => {
              accordionHeader.classList.remove("active");
            });
            // Add active Class To The accordionHeader Clicked
            accordionHeader.classList.add("active");
          }
        });
      });
    });
  }
};

const changeHeader = () => {
  // Get Navbar
  let headerHTML = document.querySelector(".header");
  // Set height = 0 TO Push The Header Image Block To Top
  headerHTML.style.height = 0;
  // If No Header Image Block Revert
  if (!document.querySelector(".header-image-block")) {
    headerHTML.style.height = "auto";
  }
};

const pageState = () => {
  if (document.querySelector("#page-state")) {
    // siteLogo
    let siteLogo = document.querySelector(
      ".header .header-bar-bottom .atom-logo"
    );
    // Check page state
    let pageState = document.querySelector("#page-state");
    // pageBgColorState
    let pageBgColorState = pageState.dataset.bgColor;
    // pageLogoSizeState
    let pageLogoSizeState = pageState.dataset.logoSize;
    // pageNavColorState
    let pageLogoNavColorState = pageState.dataset.navLogoColor;

    // Keep for testing
    // console.log(pageBgColorState, pageLogoNavColorState, pageLogoSizeState);

    // Track & Update pageBgColorState
    if (pageBgColorState) {
      document.body.style.backgroundColor = pageBgColorState;
    } else {
      document.body.style.backgroundColor = "#F7F4F4";
    }
    // Track & Update pageLogoSizeState
    if (pageLogoSizeState == "small-logo") {
      siteLogo.classList.remove("big-logo");
    }
    if (pageLogoSizeState == "big-logo") {
      siteLogo.classList.add("big-logo");
    }
    // Track & Update pageLogoNavColorState
    if (pageLogoNavColorState == "white") {
      
      siteLogo.classList.add("white-logo");
      document.querySelectorAll("body:not(.wp-admin) .header-bar-top a")
        .forEach((elem) => {
          elem.style.color = "white";
        });

        document.querySelectorAll("body:not(.wp-admin) .header-bar-top .gt_selector").forEach((elem) => {
          elem.style.color = "white";

          elem.classList.add("gt_white");
          elem.classList.remove("gt_black");
        });
    }
    if (pageLogoNavColorState == "black") {

      siteLogo.classList.remove("white-logo");
      document.querySelectorAll("body:not(.wp-admin) .header-bar-top a")
        .forEach((elem) => {
          elem.style.color = "black";
        });

        document.querySelectorAll("body:not(.wp-admin) .header-bar-top .gt_selector").forEach((elem) => {
          elem.style.color = "black";

          elem.classList.add("gt_black");
          elem.classList.remove("gt_white");
        });
    }
  }
};

// fitText - add id to titles
const addTitleId = () => {
  let singleTitle = document.querySelectorAll(".single-title");
  if (singleTitle.length > -1) {
    singleTitle.forEach((articleTitle, index) => {
      articleTitle.id = "bigtext-" + index;
      articleTitle.style.width = "100%";
      $("#bigtext-" + index).bigtext();
    });
  }
};

const initLightbox = () => {
  if (document.querySelector(".lightbox-wrapper")) {
    let lightbox = document.querySelector(".lightbox-wrapper");
    let closeBtn = document.querySelector("#close-btn");
    let lightboxImg = document.querySelector("#lightbox-img");
    let lightboxVideo = document.querySelector("#lightbox-video");
    document.querySelectorAll(".img-wrapper").forEach((img) => {
      img.addEventListener("click", () => {
        document.body.classList.add("no-scroll");
        lightbox.classList.add("active");
        if (img.querySelector("img")) {
          lightboxImg.src = img.querySelector("img").src;
          lightboxVideo.style.display = "none";
          lightboxImg.style.display = "block";
        }
        if (img.querySelector("video")) {
          lightboxVideo.src = img.querySelector("video").src;
          lightboxImg.style.display = "none";
          lightboxVideo.style.display = "block";
        }
      });
    });

    closeBtn.addEventListener("click", () => {
      lightbox.classList.remove("active");
      document.body.classList.remove("no-scroll");
    });
  }
};

const addCurrentNavItem = () => {
  let navLinks = document.querySelectorAll(".nav-main-link");
  let logo = document.querySelector(".header-bar-bottom .atom-logo");
  let footerLogo = document.querySelector(".atom-icon-footer-logo");

  // When the logo is clicked remove class
  logo.addEventListener("click", function () {
    navLinks.forEach(function (removal) {
      removal.classList.remove("current_page_item");
    });
  });
  // When footer logo is pressed remove class and scroll top home page
  footerLogo.addEventListener("click", () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    navLinks.forEach(function (removal) {
      removal.classList.remove("current_page_item");
    });
  });

  navLinks.forEach(function (item) {
    item.addEventListener("click", function () {
      navLinks.forEach(function (removal) {
        removal.classList.remove("current_page_item");
      });

      item.classList.add("current_page_item");
    });
  });
};

// Check article title font size and match the line height
function matchFontSize() {
  if (document.querySelector(".article-title h1")) {
    let title = document.querySelector(".article-title h1");
    let text = title.innerText;
    let fontSize = window.getComputedStyle(title).fontSize;
    // If the text contains a descending character we need to allow for more space below
    if ( text.includes('g') || text.includes('j') || text.includes('p') || text.includes('q') || text.includes('y') ) {
      title.classList.add('descender-title');
    }
    document.querySelector(".article-title h1").style.lineHeight = fontSize;
  }
}

const globalUrl = document.location.origin;




// Loads newsletter
function gravityNewsletterLoader() {

  $("#gf_button_form_container_1").fadeIn();
  $.get(
      globalUrl + "/wp-admin/admin-ajax.php?action=gf_button_get_form&form_id=1",
      function (response) {
          $("#gf_button_form_container_1").html(response).fadeIn();
      }
  );
  }

// Loads main form
function gravityContactFormLoader() {
  $("#gf_button_form_container_2").fadeIn();
  $.get(
    globalUrl + "/wp-admin/admin-ajax.php?action=gf_button_get_form&form_id=2",
    function (response) {
      $("#gf_button_form_container_2").html(response).fadeIn();
    }
  );
}

// Loads main form
function gravityDataCaptureLoader() {
  $("#gf_button_form_container_3").fadeIn();
  $.get(
    globalUrl + "/wp-admin/admin-ajax.php?action=gf_button_get_form&form_id=3",
    function (response) {
      $("#gf_button_form_container_3").html(response).fadeIn();
    }
  );
}

// Loads main form
function gravityDataCaptureLoader2() {
  $("#gf_button_form_container_4").fadeIn();
  $.get(
    globalUrl + "/wp-admin/admin-ajax.php?action=gf_button_get_form&form_id=4",
    function (response) {
      $("#gf_button_form_container_4").html(response).fadeIn();
    }
  );
}

// Loads main form
function gravityDataCaptureLoader3() {
  $("#gf_button_form_container_5").fadeIn();
  $.get(
    globalUrl + "/wp-admin/admin-ajax.php?action=gf_button_get_form&form_id=5",
    function (response) {
      $("#gf_button_form_container_5").html(response).fadeIn();
    }
  );
}



const textareaRows = () => {
  let textareaForms = document.querySelectorAll(
    ".ginput_container_textarea textarea"
  );
  textareaForms.forEach((textarea) => {
    textarea.rows = 5;
    textarea.style.width = "100%";
  });
};

function scrollTop() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

// For form rendered or render with validation errors
// the custom JS is never called again
// so we use gform_post_render hook
// as is fired every time the form is rendered
// to allow custom functions to be executed.
$(document).on("gform_post_render", function () {
  textareaRows();
  if (window.location.pathname == "/contact/") {
    formFileUpload();
    // console.log("upload field added");
  }
});

// Use init() to run all functions on swup
function init() {
  slider.init();

  npl.setEventListener(state);

  window.addEventListener("resize", () => {
    addTitleId();
    matchFontSize();
  });

  gravityContactFormLoader();
  gravityDataCaptureLoader();
  gravityDataCaptureLoader2();
  gravityDataCaptureLoader3();
  addTitleId();
  matchFontSize();
  initAccordion(); 
  changeHeader();
  setTimeout(pageState, 100);
  inheritLinks();
  isAnimation();
  projectFilter();
  initLightbox();
  addCurrentNavItem();
  scroller.init();
  scrollTop();

  Vimeo.init(state);

 // When the form is submited we can change the newsletter
  $(document).on("gform_confirmation_loaded", (e) => {
    newsletterFooterTitle.style.display = "none";
    newsletterP.style.display = "none";
    let newWrapper = document.createElement("div");
    newWrapper.classList.add("flex", "flex-column", "justify-center");
    newWrapper.style.height = "100%";
    let wrapperTitle = document.createElement("p");
    wrapperTitle.classList.add("fs-60", "w-50", "mb-0");
    wrapperTitle.textContent = "Thank you for joining";
    let wrapperP = document.createElement("p");
    wrapperP.classList.add("fs-20");
    wrapperP.textContent = "We’ll be in touch soon";

    newWrapper.append(wrapperTitle);
    newWrapper.append(wrapperP);
    document.querySelector(".newsletter-form").append(newWrapper);
  });
  setTimeout(() => {
      gravityNewsletterLoader();
  }, 2000);
}
init();
swup.on("contentReplaced", init);

// Triggers before the content is replaced
swup.on("willReplaceContent", () => {
  // Close newsletter and reset if left open
  if (
    document.querySelector(".footer-newsletter").classList.contains("active")
  ) {
    document.querySelector(".footer-newsletter").classList.remove("active");
    newsletterCloseBtn.classList.remove("active");
    newsletterFooterTitle.textContent = "Unlock news, views & culture";
    newsletterFakeBtn.classList.add("btn");
    newsletterFooterTitle.style.display = "block";
    newsletterP.style.display = "block";
  }
});


// GTranslate - Remove Default "Select Language" option & replace language name with code

document.addEventListener("DOMContentLoaded", function () {
  // Select all .gt_selector elements within .nav-main-item or .menu_translate
  const languageSelects = document.querySelectorAll(
    ".nav-main-item .gt_selector, .menu_translate .gt_selector"
  );

  languageSelects.forEach((languageSelect) => {
    // Remove the default "Select Language" option
    const defaultOption = languageSelect.querySelector('option[value=""]');
    if (defaultOption) {
      defaultOption.remove();
    }

    // Function to update the options
    const updateOptions = () => {
      const options = Array.from(languageSelect.querySelectorAll("option"));

      // Replace language name with language code
      options.forEach((option) => {
        const value = option.value;
        const languageCode = value.split("|")[1];

        if (languageCode) {
          option.textContent = languageCode.toUpperCase();
        }
      });

      // Move the selected option to the top
      const selectedOption = languageSelect.querySelector("option:checked");
      if (selectedOption) {
        // Remove the selected option from its current position
        selectedOption.remove();
        // Prepend it to the beginning of the select options
        languageSelect.prepend(selectedOption);
      }
    };

    // Initial update
    updateOptions();

    // Update options on change
    languageSelect.addEventListener("change", updateOptions);
  });
});


